import { call, put, select, take, takeEvery, takeLatest, takeLeading } from "redux-saga/effects";
import { fetchCreditsBalanceAPI, fetchCreditTransactionsAPI, fetchPlansAPI } from "../../API/API";
import { types } from "../action-types";
import {
  getSelectedPlanFromSearch,
  getSelectedPlanLandingModalType,
  OPEN_UPGRADE_MODAL_EVENT,
  shouldShowFreeTrialDashboardBanner,
} from "../../shared/billing";

const DASHBOARD_MODAL_SESSION_KEY = "openedUpgradeModalOnDashboard";

function* waitUntilLoaded(selector, successType) {
  const isLoaded = yield select(selector);
  if (!isLoaded) {
    yield take(successType);
  }
}

function* checkFreeTrialModalSaga() {
  yield call(
    waitUntilLoaded,
    (state) => Array.isArray(state.plansReducer.plans?.data) && state.plansReducer.plans.data.length > 0,
    types.FETCH_PLANS_SUCCESS
  );
  yield call(
    waitUntilLoaded,
    (state) => state.plansReducer.creditsBalanceLoaded,
    types.FETCH_CREDITS_BALANCE_SUCCESS
  );
  yield call(
    waitUntilLoaded,
    (state) => Boolean(state.dashbaordReducer.details),
    types.GET_DASHBOARD_DETAILS_SUCCESS
  );

  if (sessionStorage.getItem(DASHBOARD_MODAL_SESSION_KEY) === "true") return;

  const { creditsBalance, creditsBalanceError, plans } = yield select(
    (state) => state.plansReducer
  );

  if (
    creditsBalanceError ||
    !shouldShowFreeTrialDashboardBanner(creditsBalance) ||
    !Array.isArray(plans?.data) ||
    plans.data.length === 0
  ) {
    return;
  }

  window.dispatchEvent(
    new CustomEvent("open-upgrade-plan-modal", { detail: { selectedPlan: "starter" } })
  );
  sessionStorage.setItem(DASHBOARD_MODAL_SESSION_KEY, "true");
}

export function* watchFreeTrialModalSaga() {
  yield takeEvery(types.FETCH_PLANS_REQUESTED, checkFreeTrialModalSaga);
}

function* fetchPlansSaga() {
  try {
    const response = yield call(fetchPlansAPI);
    yield put({
      type: types.FETCH_PLANS_SUCCESS,
      payload: response?.data,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_PLANS_FAILURE,
      payload: error,
    });
  }
}

function* fetchCreditsBalanceSaga() {
  try {
    const response = yield call(fetchCreditsBalanceAPI);
    yield put({
      type: types.FETCH_CREDITS_BALANCE_SUCCESS,
      payload: response?.data,
    });

    const queryParamModalDirty = yield select(
      (state) => state.plansReducer.queryParamModalDirty
    );
    const selectedPlan = getSelectedPlanFromSearch(window.location.search);
    const userProfile = JSON.parse(localStorage.getItem("userProfile") || "null");
    const isMasterAccount = userProfile?.MasterAccountId == null;

    if (queryParamModalDirty && selectedPlan && isMasterAccount) {
      const modalType = getSelectedPlanLandingModalType({
        search: window.location.search,
        creditsBalanceResponse: response?.data,
      });

      yield put({ type: types.QUERY_PARAM_MODAL_CHECKED });

      if (modalType) {
        window.dispatchEvent(
          new CustomEvent(OPEN_UPGRADE_MODAL_EVENT, {
            detail: { selectedPlan, modalType },
          })
        );
      }
    } else if (queryParamModalDirty && selectedPlan) {
      yield put({ type: types.QUERY_PARAM_MODAL_CHECKED });
    }
  } catch (error) {
    yield put({
      type: types.FETCH_CREDITS_BALANCE_FAILURE,
      payload: error,
    });
  }
}

export function* watchFetchPlansSaga() {
  yield takeLeading(types.FETCH_PLANS_REQUESTED, fetchPlansSaga);
}

export function* watchFetchCreditsBalanceSaga() {
  yield takeLatest(
    types.FETCH_CREDITS_BALANCE_REQUESTED,
    fetchCreditsBalanceSaga
  );
}

function* fetchCreditTransactionsSaga(action) {
  try {
    const response = yield call(fetchCreditTransactionsAPI, action.payload);
    yield put({
      type: types.FETCH_CREDIT_TRANSACTIONS_SUCCESS,
      payload: response?.data,
    });
  } catch (error) {
    yield put({
      type: types.FETCH_CREDIT_TRANSACTIONS_FAILURE,
      payload: error,
    });
  }
}

export function* watchFetchCreditTransactionsSaga() {
  yield takeLatest(
    types.FETCH_CREDIT_TRANSACTIONS_REQUESTED,
    fetchCreditTransactionsSaga
  );
}
